import { jsx as r } from "react/jsx-runtime";
const o = ({
  size: e
}) => {
  switch (e) {
    case "sm":
      return /* @__PURE__ */ r("path", { d: "M3.66501 8.50244V7.50244H12.3317V8.50244H3.66501Z", fill: "currentColor" });
    case "lg":
      return /* @__PURE__ */ r("path", { d: "M5.5 12.7524V11.2524H18.5V12.7524H5.5Z", fill: "currentColor" });
    case "md":
    default:
      return /* @__PURE__ */ r("path", { d: "M4.58167 10.6274V9.37744H15.415V10.6274H4.58167Z", fill: "currentColor" });
  }
}, l = ({
  size: e
}) => {
  switch (e) {
    case "sm":
      return /* @__PURE__ */ r("path", { d: "M3.2 8.76081V7.24414H12.8043V8.76081H3.2Z", fill: "currentColor" });
    case "lg":
      return /* @__PURE__ */ r("path", { d: "M4.79475 13.14V10.865H19.2013V13.14H4.79475Z", fill: "currentColor" });
    case "md":
    default:
      return /* @__PURE__ */ r("path", { d: "M3.99933 10.9505V9.05469H16.0047V10.9505H3.99933Z", fill: "currentColor" });
  }
}, a = ({
  size: e = "md",
  weight: t = "default"
}) => {
  switch (t) {
    case "bold":
      return /* @__PURE__ */ r(l, { size: e });
    case "book":
    case "default":
      return /* @__PURE__ */ r(o, { size: e });
  }
};
export {
  a as default
};
//# sourceMappingURL=DIconRemove.js.map
